<body class="dashboard dashboard-bg superadmin-dashboard">
  <app-header></app-header>

  <div class="body-container collapsed">
    <app-sidebar></app-sidebar>

    <div class="body-content">
      <div class="row">
        <div class="col p-0">
          <app-page-header [title]="'Pre-Signup Users' | translate" iconClass="fas fa-users"></app-page-header>
        </div>
      </div>

      <app-progress-spinner [show]="isLoading || (dataSource.isLoading$ | async)"></app-progress-spinner>

      <div class="white-box">
        <mat-form-field>
          <mat-label>{{ 'Search' | translate }}</mat-label>
          <input matInput #searchField />
          <mat-icon matPrefix class="mr-3">
            <i class="fas fa-search"></i>
          </mat-icon>
        </mat-form-field>

        <table mat-table [dataSource]="dataSource" matSort matSortActive="id" matSortDirection="asc"
          matSortDisableClear>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
            <td mat-cell *matCellDef="let user">{{user.id}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Status' | translate }}</th>
            <td mat-cell *matCellDef="let user">
              @if (user.status === 0) {
                <mat-icon [title]="user.statusName">
                  <i class="fas fa-exclamation-circle color-primary-light"></i>
                </mat-icon>
              }

              @if (user.status === 1) {
                <mat-icon [title]="user.statusName">
                  <i class="fas fa-check-circle color-secondary"></i>
                </mat-icon>
              }

              @if (user.status === 2) {
                <mat-icon [title]="user.statusName">
                  <i class="fas fa-times-circle color-accent"></i>
                </mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'First Name' | translate }}</th>
            <td mat-cell *matCellDef="let user">{{user.firstName || 'N/A'}}</td>
          </ng-container>

          <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Last Name' | translate }}</th>
            <td mat-cell *matCellDef="let user">{{user.lastName || 'N/A'}}</td>
          </ng-container>

          <ng-container matColumnDef="emailId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Email' | translate }}</th>
            <td mat-cell *matCellDef="let user">{{user.emailId || 'N/A'}}</td>
          </ng-container>

          <ng-container matColumnDef="companyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Company Name' | translate }}</th>
            <td mat-cell *matCellDef="let user">{{user.companyName || 'N/A'}}</td>
          </ng-container>

          <ng-container matColumnDef="mobileNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Mobile Number' | translate }}</th>
            <td mat-cell *matCellDef="let user">{{user.mobileNumber || 'N/A'}}</td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th class="action-column" mat-header-cell *matHeaderCellDef>{{ 'Action' | translate }}</th>
            <td class="action-column" mat-cell *matCellDef="let user">
              @if (user.status === 0) {
                <mat-icon class="action-icon" [title]="'Approve' | translate"
                  (click)="approveUser(user)">
                  <i class="fas fa-user-check"></i>
                </mat-icon>
              }

              @if (user.status === 0) {
                <mat-icon class="action-icon color-accent" [title]="'Decline' | translate"
                  (click)="declineUser(user)">
                  <i class="fas fa-user-times"></i>
                </mat-icon>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
          [class.even-row]="even"></tr>
        </table>

        <mat-paginator [length]="dataSource.count$ | async" [pageSizeOptions]="[5, 10, 20]" [pageSize]="10"
        showFirstLastButtons></mat-paginator>
      </div>

      <div class="row">
        <div class="col-lg-3 offset-lg-9">
          <mat-form-field>
            <mat-label>{{ 'Time Zone' | translate }}</mat-label>
            <input matInput [(ngModel)]="timeZoneLabel" readonly />
            <mat-icon matPrefix class="mr-3">
              <i class="fas fa-globe"></i>
            </mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div class="clearfix"></div>
      <app-footer></app-footer>
    </div>

    <div class="clearfix"></div>
  </div>
</body>
